import { Flex, TextHeadingOne } from '@cko/primitives';
import React from 'react';
import styled from 'styled-components';
import { useFeatureFlags } from '@cko/dashboard-shared';

import { PrimaryHeader } from '../../../../../config/shared/types';
import { FeatureFlagId } from '../../../../../config/shared/enums/featureFlagIds';
import { BreadCrumb, BreadcrumbsItem } from '../BreadCrumb';
import { Description } from '../Description';
import { AvailableMenuItem } from '../../../../../providers/NavigationProvider/types';
import { TabbedMenu } from '../TabbedMenu';
import { shouldShowBreadcrumb } from './breadcrumb';

const Container = styled(Flex)`
  flex-direction: column;
  gap: var(--layout-soybean);
`;

const OldContainer = styled(Flex)`
  flex-direction: column;
  gap: var(--layout-soybean);
  margin-bottom: var(--layout-shoe);
`;

export type MainHeaderProps = {
  config: PrimaryHeader;
  breadCrumbItems: Array<BreadcrumbsItem>;
  menuItems?: Array<AvailableMenuItem>;
  dynamicDescription?: string;
};

export const MainHeader = ({
  config,
  breadCrumbItems,
  menuItems,
  dynamicDescription,
}: MainHeaderProps) => {
  const {
    title,
    description,
    external_link: externalLink,
    dynamic_description: dynamicDescriptionEnabled,
  } = config;
  const { getFeatureFlag } = useFeatureFlags();
  const isNewHeaderEnabled = getFeatureFlag(FeatureFlagId.NEW_HEADINGS);

  // If you are having issues with your breadcrumbs, make sure there is a title defined on the route
  // config.
  const showBreadcrumb = shouldShowBreadcrumb(breadCrumbItems, menuItems);

  if (!isNewHeaderEnabled) {
    return <OldContainer>{menuItems && <TabbedMenu menuItems={menuItems} />}</OldContainer>;
  }

  return (
    <Container>
      {showBreadcrumb && <BreadCrumb items={breadCrumbItems} />}
      <TextHeadingOne>{title}</TextHeadingOne>
      <Description
        descriptionText={description}
        documentation={externalLink}
        dynamicDescriptionEnabled={dynamicDescriptionEnabled}
        dynamicDescription={dynamicDescription}
      />
      {menuItems && <TabbedMenu menuItems={menuItems} />}
    </Container>
  );
};
